import React from 'react';
import AuthScreen from '../../components/Auth/AuthScreen';
import AuthForm from '../../components/Auth/AuthForm';

const Login: React.FC = () => (
  <AuthScreen>
    <AuthForm defaultMode="signin" />
  </AuthScreen>
);

export default Login;
